import {FormGroup} from '@angular/forms';
import {AdvertisingPlatformInfo} from '../../models/advertising-platform-info';
import {PartnerAdvertisingPlatform} from '../../models/partner/partner-advertising-platform';

export abstract class AdvertisingPlatformInfoForm {

  protected formGroup: FormGroup = new FormGroup({});

  getFormGroup(): FormGroup {
    return this.formGroup;
  }

  static getPlatformName(): string {
    throw new Error('Method not implemented.');
  }

  getConfigurationInfoValues() {
    const {currencyId, ...values} = this.formGroup.value;

    return values;
  }

  hasFormControl(name: string): boolean {
    return this.formGroup.get(name) !== null;
  }

  update(data: PartnerAdvertisingPlatform): void {
    this.formGroup.patchValue({
      currencyId: data.currencyId,
      ...data.configurationInfo,
    });
  }
}
